import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxImageGalleryComponent, GALLERY_IMAGE, GALLERY_CONF } from "ngx-image-gallery";
 
import { ClassroomService,MasterService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import { AppGlobals } from '../../shared/app.global';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-eventgallary',
  templateUrl: './eventgallary.component.html',
  styleUrls: ['./eventgallary.component.scss'],
  providers:[ClassroomService,MasterService]
})
export class EventgallaryComponent implements OnInit {

  @ViewChild(NgxImageGalleryComponent) ngxImageGallery: NgxImageGalleryComponent;
  
  // gallery configuration
  conf: GALLERY_CONF = {
    imageOffset: '0px',
    showDeleteControl: false,
    showImageTitle: false,
  };

  images: GALLERY_IMAGE[] = [
    {
      url: "https://images.pexels.com/photos/669013/pexels-photo-669013.jpeg?w=1260", 
      altText: 'woman-in-black-blazer-holding-blue-cup', 
      title: 'woman-in-black-blazer-holding-blue-cup',
      thumbnailUrl: "https://images.pexels.com/photos/669013/pexels-photo-669013.jpeg?w=60"
    },
    {
      url: "https://images.pexels.com/photos/669006/pexels-photo-669006.jpeg?w=1260", 
      altText: 'two-woman-standing-on-the-ground-and-staring-at-the-mountain', 
      extUrl: 'https://www.pexels.com/photo/two-woman-standing-on-the-ground-and-staring-at-the-mountain-669006/',
      thumbnailUrl: "https://images.pexels.com/photos/669006/pexels-photo-669006.jpeg?w=60"
    },
  ];

  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
 
  
  cnid:any;
  
  arrftype=[{name:'Url'},{name:'File'}];
  ftype:any;
  fpath:any;
  upfilenm:any;
  fnm:any;
  arrstudoc:any=[];
  fileToUpload: File = null;

  fData: FormData = new FormData;
  notetype=[{name:'Homework'},{name:'Activity'},{name:'Information'}];
  objfilt:any={};
    objsch:any={};
    arrasch:any=[];
    sections:any=[];
    classes:any=[];
    arrsubjects:any=[];
    arrschnote:any=[];
    arrschnoteda:any=[];
    arrrepdata:any=[];
    arrcourse:any=[];
    fmodel:any={clid:'0',crid:'0',scid:'0',prid:'0'};
    arrimages:any=[];

  constructor(private http: HttpClient, private cservice: ClassroomService,private mservice:MasterService,private modalService: NgbModal,private apglobal:AppGlobals) { }

  ngOnInit(): void {
    this.getcourselist();
  }

 
  masclass() {
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
            //this.fmodel.clid=resultArray[0].clid;
            this.objsch.clid=resultArray[0].clid;
            this.massection();
           
           
        },
        error => console.log("Error :: " + error)
        )
  }

 
  massection() {
    this.mservice.massection()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.sections = resultArray;
            this.fmodel.scid=resultArray[0].scid;
            this.objsch.scid=resultArray[0].scid;
            this.Bindtable();
        },
        error => console.log("Error :: " + error)
        )
  }

  getcourselist() {
    this.mservice.mascourse()
        .subscribe(
        resultArray => {
            console.log('class-result', resultArray);
            this.arrcourse = resultArray;
          //  this.fmodel.crid=resultArray[0].crid;
            this.objsch.crid=resultArray[0].crid;
            this.masclass(); 

        },
        error => console.log("Error :: " + error)
        )
  }
  
 

    

    
    Bindtable() {
      debugger
      
      
      this.cservice.getalbum()
          .subscribe(resultArray => {
             console.log('ret-select', resultArray);
              this.arrschnote = resultArray;
              //alert (resultArray.message);

          }, error =>
              alert('error in connection')
          );
      
  }


  bindnoteda(cnid) {
    debugger
    
    
    this.cservice.getalbumd(cnid)
        .subscribe(resultArray => {
           console.log('ret-select', resultArray);
            this.arrimages = resultArray;
            //alert (resultArray.message);

        }, error =>
            alert('error in connection')
        );
    
}

delalbdet(obj) {
  debugger
  if (confirm('Are you sure you want to delete'))
  {
  this.cservice.deletalbumd(obj)
      .subscribe(resultArray => {
        // console.log('ret-select', resultArray);
          //this.arrschnoteda = resultArray;
          alert (resultArray.message);
this.bindnoteda(obj.abid);
      }, error =>
          alert('error in connection')
      );
    }
}

delalbh(obj) {
  debugger
  if (confirm('Are you sure you want to delete'))
  {
  this.cservice.deletalbumh(obj)
      .subscribe(resultArray => {
        // console.log('ret-select', resultArray);
          //this.arrschnoteda = resultArray;
          alert (resultArray.message);
          this.Bindtable();
      }, error =>
          alert('error in connection')
      );
    }
}


openlink(url){
  

  window.open(url,'','_blank');
}
SaveDetails() {
    
  console.log('save-model', this.objsch);
  var dbnm='';
  

  this.cservice.savealbum(this.objsch)
      .subscribe(resultArray => {
          console.log('ret-save', resultArray);
          
          alert (resultArray.message);
          if(resultArray.status=='success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
           // this.Getsel_sp_massubgp();
           this.Bindtable();
          }
          

      }, error =>
          alert('error in connection')
      );
 // this.closeAddExpenseModal.nativeElement.click();

}

viewfile(fpath)
{
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
  var path=this.cservice.callurl.replace("/api/v3","");
   var url=path+fpath;
   console.log("url",url)
   window.open(url,'');

}

    opensubject(content,objdata,cmd) {
      debugger

      console.log(objdata);
      if(cmd=='insert')
      {
        this.objsch={};
       
        
        //console.log('date',this.sservice.getdatetoday().toString())
       // this.objsch.cntype='Homework';
        this.objsch.abid='0';
        this.objsch.abnm='';
       // this.objsch.cncontent='';
       // this.objsch.cndt=this.apglobal.getdatetoday();
       // this.objsch.cnduedt=this.apglobal.getdatetoday();
        this.objsch.clid='0';
        this.objsch.crid='0';
        this.objsch.scid='0';
        this.objsch.abnm="";
      
        //this.objsch.crid=this.fmodel.crid;
        this.objsch.oprtype='inserth';
       
      }
    
      else if(cmd=='update')
      {
  debugger
        
        this.objsch=objdata;
        
       // this.objsch.stuid=objdata.stuid;
        this.objsch.oprtype='updateh';
      }
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'md'
        
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }


    openinfo(content,nfid)
{
  //this.getstudentdocs(bkid);
//this.masgeneral('Student Docs');
//this.bindnoteda(nfid);
  this.objfilt=nfid;
  // this.fpath='';
  // this.ftype="Url";
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'md'
   }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
       // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}


openimggal(content,nfid)
{
  //this.getstudentdocs(bkid);
//this.masgeneral('Student Docs');
this.cnid=nfid;
this.bindnoteda(nfid);
  //this.objfilt=nfid;
  // this.fpath='';
  // this.ftype="Url";
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
   }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
       // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

upload(files: FileList) {
  debugger;
  this.upfilenm=files.item(0).name;
  this.fileToUpload = files.item(0);


  
}

fileupload()
{
debugger

console.log('file data',JSON.stringify(this.fileToUpload));

this.cservice.uploadalbimages(this.fileToUpload,this.cnid)
.subscribe(fresult => {
   // console.log('ret',JSON.stringify(fresult));
    alert (fresult.message);
    if(fresult.status=='Success')
{
// let localmodref=this.modalRef;
// localmodref.close();
//this.Refreshsummary();
this.fileToUpload=null;
this.upfilenm="";

this.objsch.fnm="";

this.bindnoteda(this.cnid);
}
    
}, error => 
alert('error during uploading')

);



}


delnoteda(stuid) {
  if(confirm("Are you sure you wan't to delete?"))
  {
  this.cservice.delnoteda(stuid)
      .subscribe(
      resultArray => {
          console.log('arrmtongue', resultArray);
          //this.arrstudoc = resultArray;
          alert(resultArray.message);
          this.bindnoteda(this.cnid);
         
      },
      error => console.log("Error :: " + error)
      )
    }
}

openGallery(index: number = 0) {
  this.ngxImageGallery.open(index);
}
  
// close gallery
closeGallery() {
  this.ngxImageGallery.close();
}
  
// set new active(visible) image in gallery
newImage(index: number = 0) {
  this.ngxImageGallery.setActiveImage(index);
}
  
// next image in gallery
nextImage(index: number = 0) {
  this.ngxImageGallery.next();
}
  
// prev image in gallery
prevImage(index: number = 0) {
  this.ngxImageGallery.prev();
}
  
/**************************************************/
  
// EVENTS
// callback on gallery opened
galleryOpened(index) {
  console.info('Gallery opened at index ', index);
}

// callback on gallery closed
galleryClosed() {
  console.info('Gallery closed.');
}

// callback on gallery image clicked
galleryImageClicked(index) {
  console.info('Gallery image clicked with index ', index);
}

// callback on gallery image changed
galleryImageChanged(index) {
  console.info('Gallery image changed to index ', index);
}

// callback on user clicked delete button
deleteImage(index) {
  console.info('Delete image at index ', index);
}

}

